import React, { useState, useRef } from 'react';
import { Upload, X, Image } from 'lucide-react';
import { api } from '../../utils/api';

const ImageUploadField = ({ value, onChange, folder = 'images', label = 'Image', accept = 'image/*,.gif', showPreview = true, previewClass = 'w-24 h-24 object-cover rounded' }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleUpload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const result = await api.uploadImage(file, folder);
      onChange(result.url);
    } catch (err) {
      alert('Upload failed: ' + err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-2">
      {label && <label className="block text-sm font-medium text-gray-700">{label}</label>}
      <div className="flex items-start gap-3">
        {/* Preview */}
        {showPreview && value && (
          <div className="relative flex-shrink-0 group">
            <img src={value} alt="" className={previewClass} />
            <button
              onClick={() => onChange('')}
              className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <X size={10} />
            </button>
          </div>
        )}

        <div className="flex-1 space-y-2">
          {/* Upload Button */}
          <button
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="flex items-center gap-2 px-4 py-2 bg-gray-900 text-white text-sm rounded hover:bg-gray-800 transition-colors disabled:opacity-50"
          >
            <Upload size={14} />
            {uploading ? 'Uploading...' : value ? 'Replace' : 'Upload'}
          </button>
          <input
            ref={inputRef}
            type="file"
            accept={accept}
            className="hidden"
            onChange={(e) => { if (e.target.files[0]) handleUpload(e.target.files[0]); e.target.value = ''; }}
          />

          {/* URL fallback - small text input */}
          <input
            type="text"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder="or paste URL"
            className="w-full px-3 py-1.5 border border-gray-200 rounded text-xs text-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageUploadField;
